import { Tooth, ToothForSend } from '@/pages/BrushMapPage/tooth'
import { HEXcolor } from '@/shared/types'

export class BrushMapTeeth {
  public teeth: Tooth[]

  constructor() {
    this.initTeeth()
  }

  public initTeeth(): void {
    this.teeth = this.getInitialTeeth()
  }

  public getTeethForSend(): ToothForSend[] {
    return this.teeth.map((tooth) => tooth.getTeethForSend())
  }

  public clearArrowColorTeeth(): void {
    this.teeth.forEach((tooth: Tooth) => tooth.clearArrowColors())
  }

  public deleteColorFromTeeth(deletedColor: HEXcolor): void {
    const sortOut = (tooth: Tooth) => {
      if (tooth.baseColor === deletedColor) {
        tooth.clearArrowColors()
      }
    }

    this.teeth.forEach(sortOut)
  }

  public getCountTeethWithFilterColor(filterColor: HEXcolor): number {
    const filteredTeethByColor = this.teeth.filter(
      (tooth) => tooth.baseColor === filterColor
    )
    const countTeethWithFilterColor = filteredTeethByColor.length

    return countTeethWithFilterColor
  }

  private getInitialTeeth(): Tooth[] {
    let index = 0
    const teeth: Tooth[] = []

    for (let quarter = 1; quarter <= 4; quarter++) {
      for (let numberTooth = 1; numberTooth <= 8; numberTooth++) {
        const id = Number(`${quarter}${numberTooth}`)
        const tooth = new Tooth(id, index)
        index++
        teeth.push(tooth)
      }
    }

    return teeth
  }
}
